import React, { Component } from 'react';
import { message } from 'antd';
import { StrategyForm } from '../Shared/Form';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class CreateView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSubmit(values) {
        this.props.store.strategyStore.create(values).then(() => {
            this.props.history.push('/a/strategies/standard');
            message.success('Strategy saved');
        });
    }
    render() {
        return (
            <div>
                <StrategyForm title="New Strategy" onSubmit={this.handleSubmit.bind(this)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Create/index.js